import { useCallback } from 'react'
import { createClaimRequest, updateFormData } from '../../../../store/claim_request/action-creators'
import { useAppDispatch } from '../../../../hooks/useAppDispatch/useAppDispatch'

export function useSaveResult() {
  const dispatch = useAppDispatch()
  const saveResult = useCallback(async (id, formData) => {
    if (!formData) {
      return
    }
    const data = formData
    if (id === 'new') {
      dispatch(createClaimRequest({ ...data }))
    } else {
      dispatch(updateFormData(id, { ...data }))
    }
  }, [])
  return { saveResult }
}
